// extracted by mini-css-extract-plugin
module.exports = {"header":"AddEditAddress_header__3z5yU","headerTitle":"AddEditAddress_headerTitle__2qenp","headerIconContainer":"AddEditAddress_headerIconContainer__1BSd-"};